import createAxios from './http'
import { saveSecret, saveKey} from '../common/js/cache'
const request = createAxios()
/**
* 拦截请求
*
*/
request.interceptors.request.use(
  config => {
    const timestamp = (new Date()).valueOf()
    const data = config.params
    const signData = {
      ...data
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

/**
 * 验证key是否合法
 */
export function getPartnerKey (params) {
  return request({
    url: '/partner/getPartnerKey.htm',
    method: 'post',
    params
  }).then((res) => {
    if (res.code == 9000200){
      saveSecret(res.obj)
      saveKey(params.key)
    }
    return res
  })
}
